import * as d3 from 'd3';

export interface ZoomContainer {
  svg: d3.Selection<SVGSVGElement, unknown, null, undefined>;
  wrapper: d3.Selection<SVGGElement, unknown, null, undefined>;
  zoom: d3.ZoomBehavior<SVGSVGElement, unknown>;
}

export function createZoom(svg: SVGSVGElement): ZoomContainer {
  const d3Svg = d3.select(svg);
  let wrapper = d3Svg.select<SVGGElement>('g.zoom-wrapper');
  if (wrapper.empty()) {
    wrapper = d3Svg.append('g').attr('class', 'zoom-wrapper');
  }

  const zoom = d3
    .zoom<SVGSVGElement, unknown>()
    .scaleExtent([0.1, 5])
    .on('zoom', (event) => {
      wrapper.attr('transform', event.transform.toString());
    });

  d3Svg.call(zoom);

  return { svg: d3Svg, wrapper, zoom };
}

export function fitToView(
  zoom: ZoomContainer,
  graphWidth: number,
  graphHeight: number,
  padding = 40
): void {
  const svgNode = zoom.svg.node();
  if (!svgNode) return;
  const { width } = svgNode.getBoundingClientRect();
  if (graphWidth === 0 || graphHeight === 0) return;

  // Fit to the available width (capped at 1:1) and align to the top so tall
  // detailed diagrams remain readable and can be panned/scrolled vertically.
  const scale = Math.min((width - padding * 2) / graphWidth, 1);
  const tx = (width - graphWidth * scale) / 2;
  const ty = padding;

  const transform = d3.zoomIdentity.translate(tx, ty).scale(scale);
  zoom.svg.call(zoom.zoom.transform, transform);
}
